<template>
  <button
      class="btn orcaBtn btn-warning"
      style="min-width:200px;background-color:palevioletred;"
      :disabled="adminBusy"
      @click="run"
      type="button"
  >
    <span v-if="!adminBusy">{{ this.hard ? 'Force ' : '' }}Reopen All</span>
    <span v-else>Working...</span>
  </button>
</template>

<script>
export default {
  name: "AdminReopenAllSitesButton",

  props: {
    companyId: { required: true },
    period:    { required: true },
    adminBusy: { type: Boolean, required: true },
    withAdminLock: { type: Function, required: true },
    success: { type: Function, required: true },
    hard: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async doAction() {
      let url = `${this.crmApiPath}r3/admin/timesheets/company/${this.companyId}/reopen/all?submission_date=${this.period}`;

      if (this.hard) {
        url += `&skip_fin=false`;
      }

      await axios.post(url);
      this.$snotify?.success("All sites reopened!");
    },

    async run() {
      await this.withAdminLock(this.doAction)();
      await this.success();
    }
  }
};
</script>
